import { useTranslation } from "react-i18next";
import { Parcel } from "@/mocks/parcels";

interface StatsBarProps {
  parcels: Parcel[];
}

export default function StatsBar({ parcels }: StatsBarProps) {
  const { t } = useTranslation();

  const stats = [
    {
      label: t("admin_total_parcels"),
      value: parcels.length,
      icon: "ri-box-3-line",
      color: "bg-slate-100 text-slate-600",
    },
    {
      label: t("admin_in_transit"),
      value: parcels.filter((p) => p.status === "In Transit").length,
      icon: "ri-truck-line",
      color: "bg-sky-100 text-sky-600",
    },
    {
      label: t("admin_out_for_delivery"),
      value: parcels.filter((p) => p.status === "Out for Delivery").length,
      icon: "ri-e-bike-line",
      color: "bg-violet-100 text-violet-600",
    },
    {
      label: t("admin_delivered"),
      value: parcels.filter((p) => p.status === "Delivered").length,
      icon: "ri-checkbox-circle-line",
      color: "bg-emerald-100 text-emerald-600",
    },
    {
      label: t("admin_processing"),
      value: parcels.filter((p) => p.status === "Processing").length,
      icon: "ri-loader-4-line",
      color: "bg-amber-100 text-amber-600",
    },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 mb-6">
      {stats.map((stat) => (
        <div key={stat.label} className="bg-white rounded-xl border border-gray-100 p-4 flex items-center gap-3">
          <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${stat.color}`}>
            <i className={`${stat.icon} text-lg`} />
          </div>
          <div>
            <div className="text-xl font-bold text-slate-800">{stat.value}</div>
            <div className="text-xs text-slate-400 whitespace-nowrap">{stat.label}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
